import React, { Component } from 'react';
import { withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// ui/ux
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

class Waiting extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { height, width } = this.props;
    return (
      <Box display="flex" style={{ height, width }} alignItems="center" justifyContent="center">
        <CircularProgress color="inherit" />
      </Box>
    );
  }
}

Waiting.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object.isRequired,

  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Waiting.defaultProps = {
  width: '100%',
  height: '100%'
};

export default withTheme(Waiting);
